export class GetTableDataQualityCompletenessResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<ColumnNullRate>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityCompletenessResponse.attributeTypeMap;
    }
    constructor() {
    }
}
